<template>
  <div class="game-container" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <a class="back-button" @click="goBack">⬅ {{back_label[language]}}</a>

    <!-- Game Stats (Score, Timer) -->
    <div class="game-stats">
      <div class="score">{{score_label[language]}}: {{ score }}</div>
      <div class="timer">{{ timeleft_label[language] }}: {{ timeLeft }}s</div>
    </div>

    <div class="middle-left-container">
      <draggable class="food-container" :list="currentFoods" @change="log" itemKey="name"
        :group="{ name: 'food', pull: 'clone', put: false }">
        <template #item="{ element }">
          <div class="food-container-item">
            <img :src="element.src" :alt="element.name" class="img-fluid">
            <div>{{element.name[language]}}</div>
            <!-- <div>{{ element.category }}</div> -->
          </div>
        </template>
      </draggable>
    </div>


    <div class="middle-right-container-1">
      <!-- Category: Fat, Oil, Sugar, Sweets -->
      <div class="category-container" :key="'fat_oil_sugar_sweets'">
        <!-- <h4>{{ formatCategoryName('fat_oil_sugar_sweets') }}</h4> -->
        <draggable class="list-group horizontal-list" :list="cart.fat_oil_sugar_sweets"
          :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInCart('fat_oil_sugar_sweets')" :style="{
            backgroundImage: `url(${categoryBackgrounds.fat_oil_sugar_sweets})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            padding: '50px',
            borderRadius: '8px'
          }">
          <template #item="{ element }">
            <div class="list-group-item">
              <img :src="element.src" :alt="element.name" class="img-fluid">
            </div>
          </template>
        </draggable>
      </div>
    </div>

    <div class="middle-right-container-2">
      <!-- Category: Meat, Fish, Milk, Eggs -->
      <div class="category-container" :key="'meat_fish_milk_eggs'">
        <!-- <h4>{{ formatCategoryName('meat_fish_milk_eggs') }}</h4> -->
        <draggable class="list-group horizontal-list" :list="cart.meat_fish_milk_eggs"
          :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInCart('meat_fish_milk_eggs')" :style="{
            backgroundImage: `url(${categoryBackgrounds.meat_fish_milk_eggs})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            padding: '50px',
            borderRadius: '8px'
          }">
          <template #item="{ element }">
            <div class="list-group-item">
              <img :src="element.src" :alt="element.name" class="img-fluid">
            </div>
          </template>
        </draggable>
      </div>
    </div>


    <div class="middle-right-container-3">

      <!-- Category: Fruits -->
      <div class="category-container" :key="'fruits'">
        <!-- <h4>{{ formatCategoryName('fruits') }}</h4> -->
        <draggable class="list-group horizontal-list" :list="cart.fruits"
          :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInCart('fruits')" :style="{
            backgroundImage: `url(${categoryBackgrounds.fruits})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            padding: '50px',
            borderRadius: '8px'
          }">
          <template #item="{ element }">
            <div class="list-group-item">
              <img :src="element.src" :alt="element.name" class="img-fluid">
            </div>
          </template>
        </draggable>
      </div>
    </div>

    <div class="middle-right-container-4">

      <!-- Category: Vegetables -->
      <div class="category-container" :key="'vegetables'">
        <!-- <h4>{{ formatCategoryName('vegetables') }}</h4> -->
        <draggable class="list-group horizontal-list" :list="cart.vegetables"
          :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInCart('vegetables')" :style="{
            backgroundImage: `url(${categoryBackgrounds.vegetables})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            padding: '50px',
            borderRadius: '8px'
          }">
          <template #item="{ element }">
            <div class="list-group-item">
              <img :src="element.src" :alt="element.name" class="img-fluid">
            </div>
          </template>
        </draggable>
      </div>
    </div>

    <div class="middle-right-container-5">

      <!-- Category: Bread, Cereals, Pasta -->
      <div class="category-container" :key="'bread_cereals_pasta'">
        <!-- <h4>{{ formatCategoryName('bread_cereals_pasta') }}</h4> -->
        <draggable class="list-group horizontal-list" :list="cart.bread_cereals_pasta"
          :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInCart('bread_cereals_pasta')" :style="{
            backgroundImage: `url(${categoryBackgrounds.bread_cereals_pasta})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            padding: '50px',
            borderRadius: '8px'
          }">
          <template #item="{ element }">
            <div class="list-group-item">
              <img :src="element.src" :alt="element.name" class="img-fluid">
            </div>
          </template>
        </draggable>
      </div>
    </div>



    <MorningWinOverlay :message="overlayMessage[language]" :visible="isMorningWinOverlayVisible" />
    <MorningLoseOverlay :message="overlayMessage[language]" :visible="isMorningLoseOverlayVisible" />
    <NoonWinOverlay :message="overlayMessage[language]" :visible="isNoonWinOverlayVisible" />
    <NoonLoseOverlay :message="overlayMessage[language]" :visible="isNoonLoseOverlayVisible" />
    <AfternoonWinOverlay :message="overlayMessage[language]" :visible="isAfternoonWinOverlayVisible" />
    <AfternoonLoseOverlay :message="overlayMessage[language]" :visible="isAfternoonLoseOverlayVisible" />
    <EveningWinOverlay :message="overlayMessage[language]" :visible="isEveningWinOverlayVisible" />
    <EveningLoseOverlay :message="overlayMessage[language]" :visible="isEveningLoseOverlayVisible" />
    <ProfPepOverlay :message="overlayMessage[language]" :visible="isOverlayVisible" @start-game="onStartGame" />

    <!-- Badge for Success/Fail -->
    <div v-if="badgeMessage" :class="['badge', badgeType]">{{ badgeMessage }}</div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ProfPepOverlay from '@/components/ProfPepOverlay.vue';
import MorningWinOverlay from '@/components/MorningWinOverlay.vue';
import MorningLoseOverlay from '@/components/MorningLoseOverlay.vue';
import NoonWinOverlay from '@/components/NoonWinOverlay.vue';
import NoonLoseOverlay from '@/components/NoonLoseOverlay.vue';
import AfternoonWinOverlay from '@/components/AfternoonWinOverlay.vue';
import AfternoonLoseOverlay from '@/components/AfternoonLoseOverlay.vue';
import EveningWinOverlay from '@/components/EveningWinOverlay.vue';
import EveningLoseOverlay from '@/components/EveningLoseOverlay.vue';
import { Howler } from 'howler';
import { sounds } from '@/utils/sounds';

export default {
  components: {
    draggable,
    ProfPepOverlay,
    MorningWinOverlay,
    MorningLoseOverlay,
    NoonWinOverlay,
    NoonLoseOverlay,
    AfternoonWinOverlay,
    AfternoonLoseOverlay,
    EveningWinOverlay,
    EveningLoseOverlay,
  },
  data() {
    return {
      language: 'en',
      isSyncing: false,
      back_label : {en:"Back", el:"Πίσω", it:"Indietro", ro:"Înapoi", uk:"Назад"},
      Round_label: {en:"Round", el:"Γύρος", it:"Round", ro:"Rundă", uk:"Раунд"},
      timeleft_label: {en: "Time left", el: "Χρόνος", it: "Tempo rimasto", ro: "Timp rămas", uk: "Залишився час"},
      score_label: {en:"Score", el:"Πόντοι", it:"Punteggio", ro:"Scor", uk:"Рахунок"},
      correct_label: {en:"Correct!", el:"Σωστά!", it:"Corretto", ro:"Corect!", uk:"Правильно!"},
      wrong_label: {en:"Wrong...", el:"Λάθος...", it:"Sbagliato", ro:"Greșit...", uk:"Неправильно..."},

      // Other data properties
      // categoryBackgrounds: {
      //   bread_cereals_pasta: require('@/assets/game-elements/bread_yellow_cart.png'),
      //   fat_oil_sugar_sweets: require('@/assets/game-elements/fats_purple_cart.png'),
      //   fruits: require('@/assets/game-elements/fruits_red_cart.png'),
      //   vegetables: require('@/assets/game-elements/vegetables_green_cart.png'),
      //   meat_fish_milk_eggs: require('@/assets/game-elements/meat_blue_cart.png'),
      // },

      daypart: '', // Initialize daypart
      overlayMessage: {en:'This is the message',el:"Αυτό είναι το μήνυμα"},
      isOverlayVisible: true,
      isMorningWinOverlayVisible: false,
      isMorningLoseOverlayVisible: false,
      isNoonWinOverlayVisible: false,
      isNoonLoseOverlayVisible: false,
      isAfternoonWinOverlayVisible: false,
      isAfternoonLoseOverlayVisible: false,
      isEveningWinOverlayVisible: false,
      isEveningLoseOverlayVisible: false,
      backgroundImage: require('@/assets/game-backgrounds/background.jpg'),
      categories: {
        fat_oil_sugar_sweets: [
          { category: "fat_oil_sugar_sweets", name: {en:'cake', el:'κέικ', it:'torta', ro:'tort', uk:'торт'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cup cake', el:'καπ κέικ', it:'cup cake', ro:'tort de ceașcă', uk:'чашка торта'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cup_cake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'donuts', el:'ντόνατς', it:'ciambelle', ro:'gogoși', uk:'пончики'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/donuts.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'icecream', el:'παγωτό', it:'gelato', ro:'înghețată', uk:'морозиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/icecream.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'oil', el:'λάδι', it:'olio', ro:'ulei', uk:'масло'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/oil-1.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'oil', el:'λάδι', it:'olio', ro:'ulei', uk:'масло'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/oil-2.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'oil', el:'λάδι', it:'olio', ro:'ulei', uk:'масло'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/oil-3.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'raspberry pie ', el:'πίτα βατόμουρο', it:'torta di lamponi', ro:'placinta cu zmeura', uk:'малиновий пиріг'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/raspberry_pie.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'strawberry pie', el:'φραουλόπιτα', it:'fragola torta', ro:'placinta cu capsuni', uk:'полуничний пиріг'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/strawberry_pie.png') },

          { category: "fat_oil_sugar_sweets", name: {en:'french fries', el:'πατάτες τηγανητές', it:'patatine fritte', ro:'cartofi pai', uk:'картопля фрі'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/french_fries.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'baklava', el:'μπακλαβάς', it:'baklava', ro:'baklava', uk:'пахлава'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/baklava.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'brownie', el:'μπράουνι', it:'brownie', ro:'brownie', uk:'брауні'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/brownie.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'candy', el:'καραμέλα', it:'caramelle', ro:'bomboane', uk:'цукерки'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/candy.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cheesecake', el:'τσίζκεϊκ', it:'cheesecake', ro:'cheesecake', uk:'чізкейк'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cheesecake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'chocolate bar', el:'μπάρα σοκολάτας', it:'barretta di cioccolato', ro:'chocolate bar', uk:'плитка шоколаду'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/chocolate_bar.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'chocolate cake', el:'σοκολατένιο κέικ', it:'torta al cioccolato', ro:'tort ciocolata', uk:'шоколадний торт'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/chocolate_cake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cookie.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'pudding', el:'πουτίγκα', it:'budino', ro:'budincă', uk:'пудинг'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/pudding.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'tiramisu', el:'τιραμισού', it:'tiramisù', ro:'tiramisu', uk:'тірамісу'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/tiramisu.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'pasta flora', el:'πάστα φλώρα', it:'pasta flora', ro:'pasta-flora', uk:'паста-флора'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/pasta-flora.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'waffle', el:'βάφλα', it:'waffle', ro:'vafa', uk:'вафельний'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/waffle.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cookie-1.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cookie-2.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'croissant', el:'κρουασάν', it:'croissant', ro:'croissant', uk:'круасан'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/croissant.png') },
        ],
        meat_fish_milk_eggs: [
          { category: "meat_fish_milk_eggs", name: {en:'cheese', el:'τυρί', it:'formaggio', ro:'brânză', uk:'сир'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/cheese.png') },
          { category: "meat_fish_milk_eggs", name: {en:'eggs', el:'αυγά', it:'uova', ro:'ouă', uk:'яйця'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/eggs.png') },
          { category: "meat_fish_milk_eggs", name: {en:'fish', el:'ψάρι', it:'pesce', ro:'peşte', uk:'риба'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/fish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'ham', el:'ζαμπόν', it:'prosciutto', ro:'șuncă', uk:'шинка'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/ham.png') },
          { category: "meat_fish_milk_eggs", name: {en:'lobster', el:'αστακός', it:'aragosta', ro:'homar', uk:'лобстер'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/lobster.png') },
          { category: "meat_fish_milk_eggs", name: {en:'meat', el:'κρέας', it:'carne', ro:'carne', uk:'м\'ясо'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/meat.png') },
          { category: "meat_fish_milk_eggs", name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/milk.png') },
          { category: "meat_fish_milk_eggs", name: {en:'salmon', el:'σολομός', it:'salmone', ro:'somon', uk:'лосось'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/salmon.png') },
          { category: "meat_fish_milk_eggs", name: {en:'shrimp', el:'γαρίδα', it:'gamberetti', ro:'crevetă', uk:'креветки'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/shrimp.png') },
        
          { category: "meat_fish_milk_eggs", name: {en:'beef', el:'βοδινό κρέας', it:'manzo', ro:'vită', uk:'яловичина'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/beef.png') },
          { category: "meat_fish_milk_eggs", name: {en:'trout', el:'πεστρόφα', it:'trota', ro:'păstrăv', uk:'форель'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/trout.png') },
          { category: "meat_fish_milk_eggs", name: {en:'meat', el:'κρέας', it:'carne', ro:'carne', uk:'м\'ясо'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/meat-2.png') },
          { category: "meat_fish_milk_eggs", name: {en:'fish', el:'ψάρι', it:'pesce', ro:'peşte', uk:'риба'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/fish-2.png') },
          { category: "meat_fish_milk_eggs", name: {en:'chicken', el:'κοτόπουλο', it:'pollo', ro:'pui', uk:'курка'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/chicken.png') },
          { category: "meat_fish_milk_eggs", name: {en:'white fish', el:'λευκό ψάρι', it:'pesce bianco', ro:'pește alb', uk:'біла риба'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/white fish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'turkey', el:'γαλοπούλα', it:'tacchino', ro:'curcan', uk:'індичка'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/turkey.png') },
          { category: "meat_fish_milk_eggs", name: {en:'swordfish', el:'ξιφίας', it:'pesce spada', ro:'pește-spadă', uk:'риба-меч'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/swordfish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'shellfish', el:'οστρακοειδή', it:'crostacei', ro:'crustacee', uk:'молюски'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/shellfish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'yogurt', el:'γιαούρτι', it:'yogurt', ro:'iaurt', uk:'йогурт'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/yogurt.png') },
          { category: "meat_fish_milk_eggs", name: {en:'ricotta cheese', el:'τυρί ρικότα', it:'ricotta', ro:'brânză ricotta', uk:'сир Рікотта'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/ricotta_cheese.png') },
          { category: "meat_fish_milk_eggs", name: {en:'beef', el:'βοδινό κρέας', it:'manzo', ro:'vită', uk:'яловичина'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/beef-2.png') },

        ],
        fruits: [
          { category: "fruits", name: {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: require('@/assets/game-elements/fruits/apple.png') },
          { category: "fruits", name: {en:'banana', el:'μπανάνα', it:'banana', ro:'banană', uk:'банан'}, src: require('@/assets/game-elements/fruits/banana.png') },
          // { category: "fruits", name: {en:'coconut', el:'καρύδα', it:'cocco', ro:'nucă de cocos', uk:'кокосовий горіх'}, src: require('@/assets/game-elements/fruits/coconut.png') },
          { category: "fruits", name: {en:'dragonfruit', el:'φρούτο του δράκου', it:'frutto del drago', ro:'dragonfruit', uk:'бабовий плід'}, src: require('@/assets/game-elements/fruits/dragonfruit.png') },
          { category: "fruits", name: {en:'grapes', el:'σταφύλια', it:'uva', ro:'strugurii', uk:'виноград'}, src: require('@/assets/game-elements/fruits/grapes.png') },
          { category: "fruits", name: {en:'orange', el:'πορτοκάλι', it:'arancia', ro:'portocale', uk:'помаранчевий'}, src: require('@/assets/game-elements/fruits/orange.png') },
          { category: "fruits", name: {en:'papaya', el:'παπάγια', it:'papaya', ro:'papaya', uk:'папайя'}, src: require('@/assets/game-elements/fruits/papaya.png') },
          { category: "fruits", name: {en:'pear', el:'αχλάδι', it:'pera', ro:'pară', uk:'груша'}, src: require('@/assets/game-elements/fruits/pear.png') },
          { category: "fruits", name: {en:'pineapple', el:'ανανάς', it:'ananas', ro:'ananas', uk:'ананас'}, src: require('@/assets/game-elements/fruits/pineapple.png') },
          { category: "fruits", name: {en:'plum', el:'δαμάσκηνο', it:'prugna', ro:'prună', uk:'слива'}, src: require('@/assets/game-elements/fruits/plum.png') },
          { category: "fruits", name: {en:'pomegranate', el:'ρόδι', it:'melograno', ro:'rodie', uk:'гранат'}, src: require('@/assets/game-elements/fruits/pomegranate.png') },
          { category: "fruits", name: {en:'quince', el:'κυδώνι', it:'mela cotogna', ro:'gutui', uk:'айва'}, src: require('@/assets/game-elements/fruits/quince.png') },

          { category: "fruits", name: {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: require('@/assets/game-elements/fruits/apple-2.png') },
          { category: "fruits", name: {en:'apricot', el:'βερύκοκκο', it:'albicocca', ro:'caisă', uk:'абрикосовий'}, src: require('@/assets/game-elements/fruits/apricot.png') },
          { category: "fruits", name: {en:'cantaloupe', el:'πεπόνι', it:'melone cantalupo', ro:'pepene galben', uk:'канталупа'}, src: require('@/assets/game-elements/fruits/cantaloupe.png') },
          { category: "fruits", name: {en:'cherry', el:'κεράσι', it:'ciliegia', ro:'cireașă', uk:'вишня'}, src: require('@/assets/game-elements/fruits/cherry.png') },
          { category: "fruits", name: {en:'grapefruit', el:'γκρέιπφρουτ', it:'pompelmo', ro:'grapefruit', uk:'грейпфрут'}, src: require('@/assets/game-elements/fruits/grapefruit.png') },
          { category: "fruits", name: {en:'kiwi', el:'ακτινίδιο', it:'kiwi', ro:'kiwi', uk:'ківі'}, src: require('@/assets/game-elements/fruits/kiwi.png') },
          { category: "fruits", name: {en:'lychees', el:'λίτσι', it:'litchi', ro:'lychees', uk:'лічі'}, src: require('@/assets/game-elements/fruits/lychees.png') },
          { category: "fruits", name: {en:'nectarine', el:'νεκταρίνι', it:'nettarina', ro:'nectarina', uk:'нектарин'}, src: require('@/assets/game-elements/fruits/nectarine.png') },
          { category: "fruits", name: {en:'persimmon', el:'λωτός', it:'cachi', ro:'curmal japonez', uk:'хурма'}, src: require('@/assets/game-elements/fruits/persimmon.png') },
          { category: "fruits", name: {en:'pluot', el:'βανίλια', it:'pluot', ro:'pluot', uk:'pluot'}, src: require('@/assets/game-elements/fruits/pluot.png') },
          { category: "fruits", name: {en:'strawberry', el:'φράουλα', it:'fragola', ro:'căpșună', uk:'полуниця'}, src: require('@/assets/game-elements/fruits/strawberry.png') },
          { category: "fruits", name: {en:'tangerines', el:'μανταρίνια', it:'mandarini', ro:'mandarine', uk:'мандарини'}, src: require('@/assets/game-elements/fruits/tangerines.png') },
          { category: "fruits", name: {en:'watermelon', el:'καρπούζι', it:'anguria', ro:'pepene verde', uk:'кавун'}, src: require('@/assets/game-elements/fruits/watermelon.png') },
          { category: "fruits", name: {en:'berries', el:'μούρα', it:'bacche', ro:'fructe de padure', uk:'ягоди'}, src: require('@/assets/game-elements/fruits/berries.png') },

        ],
        vegetables: [
          // { category: "vegetables", name: {en:'avocado', el:'αβοκάντο', it:'avocado', ro:'avocado', uk:'авокадо'}, src: require('@/assets/game-elements/vegetables/avocado.png') },
          { category: "vegetables", name: {en:'beetroot', el:'παντζάρι', it:'barbabietola', ro:'sfeclă', uk:'буряк'}, src: require('@/assets/game-elements/vegetables/beetroot.png') },
          { category: "vegetables", name: {en:'broccoli', el:'μπρόκολο', it:'broccoli', ro:'broccoli', uk:'брокколі'}, src: require('@/assets/game-elements/vegetables/broccoli.png') },
          { category: "vegetables", name: {en:'cabbage', el:'λάχανο', it:'cavolo', ro:'varză', uk:'капуста'}, src: require('@/assets/game-elements/vegetables/cabbage.png') },
          { category: "vegetables", name: {en:'carrot', el:'καρότο', it:'carota', ro:'morcov', uk:'морква'}, src: require('@/assets/game-elements/vegetables/carrot.png') },
          { category: "vegetables", name: {en:'celery', el:'σέλινο', it:'sedano', ro:'țelină', uk:'селера'}, src: require('@/assets/game-elements/vegetables/celery.png') },
          { category: "vegetables", name: {en:'corn', el:'καλαμπόκι', it:'mais', ro:'porumb', uk:'кукурудза'}, src: require('@/assets/game-elements/vegetables/corn.png') },
          { category: "vegetables", name: {en:'eggplant', el:'μελιτζάνα', it:'melanzane', ro:'vânătă', uk:'баклажани'}, src: require('@/assets/game-elements/vegetables/eggplant.png') },
          { category: "vegetables", name: {en:'garlic', el:'σκόρδο', it:'aglio', ro:'usturoi', uk:'часник'}, src: require('@/assets/game-elements/vegetables/garlic.png') },
          { category: "vegetables", name: {en:'leek', el:'πράσο', it:'porro', ro:'praz', uk:'цибуля-порей'}, src: require('@/assets/game-elements/vegetables/leek.png') },
          { category: "vegetables", name: {en:'lettuce', el:'μαρούλι', it:'lattuga', ro:'salată verde', uk:'листя салату'}, src: require('@/assets/game-elements/vegetables/lettuce.png') },
          { category: "vegetables", name: {en:'pepper', el:'πιπέρι', it:'peperone', ro:'piper', uk:'перець'}, src: require('@/assets/game-elements/vegetables/pepper.png') },
          { category: "vegetables", name: {en:'pumpkin', el:'κολοκύθι', it:'zucca', ro:'dovleac', uk:'гарбуз'}, src: require('@/assets/game-elements/vegetables/pumpkin.png') },
          { category: "vegetables", name: {en:'radish', el:'ραπανάκι', it:'ravanello', ro:'ridiche', uk:'редька'}, src: require('@/assets/game-elements/vegetables/radish.png') },
          { category: "vegetables", name: {en:'tomato', el:'ντομάτα', it:'pomodoro', ro:'roșie', uk:'помідор'}, src: require('@/assets/game-elements/vegetables/tomato.png') },
          { category: "vegetables", name: {en:'zucchini', el:'κολοκυθάκι', it:'zucchine', ro:'zucchini', uk:'цукіні'}, src: require('@/assets/game-elements/vegetables/zucchini.png') },
          
          { category: "vegetables", name: {en:'artichoke', el:'αγκινάρα', it:'carciofo', ro:'anghinare', uk:'артишок'}, src: require('@/assets/game-elements/vegetables/artichoke.png') },
          { category: "vegetables", name: {en:'arugula', el:'ρόκα', it:'rucola', ro:'voinicică', uk:'рукола'}, src: require('@/assets/game-elements/vegetables/arugula.png') },
          { category: "vegetables", name: {en:'beans', el:'φασόλια', it:'fagioli', ro:'fasole', uk:'квасоля'}, src: require('@/assets/game-elements/vegetables/beans.png') },
          { category: "vegetables", name: {en:'cucumber', el:'αγγούρι', it:'cetriolo', ro:'castravete', uk:'огірок'}, src: require('@/assets/game-elements/vegetables/cucumber.png') },
          { category: "vegetables", name: {en:'daikon', el:'ραπανάκι', it:'daikon', ro:'daikon', uk:'дайкон'}, src: require('@/assets/game-elements/vegetables/daikon.png') },
          { category: "vegetables", name: {en:'okra', el:'μπάμια', it:'gombo', ro:'baume', uk:'бамія'}, src: require('@/assets/game-elements/vegetables/okra.png') },
          { category: "vegetables", name: {en:'peas', el:'αρακάς', it:'piselli', ro:'mazăre', uk:'горох'}, src: require('@/assets/game-elements/vegetables/peas.png') },
          { category: "vegetables", name: {en:'potato', el:'πατάτα', it:'patata', ro:'cartof', uk:'картопля'}, src: require('@/assets/game-elements/vegetables/potato.png') },
          { category: "vegetables", name: {en:'spinach', el:'σπανάκι', it:'spinaci', ro:'spanac', uk:'шпинат'}, src: require('@/assets/game-elements/vegetables/spinach.png') },
          { category: "vegetables", name: {en:'turnip', el:'γογγύλι', it:'rapa', ro:'nap', uk:'ріпа'}, src: require('@/assets/game-elements/vegetables/turnip.png') },
        
        ],
        bread_cereals_pasta: [
          { category: "bread_cereals_pasta", name: {en:'baguette', el:'μπαγκέτα', it:'baguette', ro:'bagheta', uk:'багет'}, src: require('@/assets/game-elements/bread_cereals_pasta/baguette.png') },
          { category: "bread_cereals_pasta", name: {en:'black bread', el:'μαύρο ψωμί', it:'pane nero', ro:'pâine neagră', uk:'хліб чорний'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread black.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-1.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-2.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-3.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-4.png') },
          { category: "bread_cereals_pasta", name: {en:'breads', el:'ψωμιά', it:'pane', ro:'coș de pâine', uk:'кошик для хліба'}, src: require('@/assets/game-elements/bread_cereals_pasta/breads-basket.png') },
          { category: "bread_cereals_pasta", name: {en:'pasta', el:'ζυμαρικά', it:'pasta', ro:'paste', uk:'паста'}, src: require('@/assets/game-elements/bread_cereals_pasta/pasta.png') },
          { category: "bread_cereals_pasta", name: {en:'pretzel', el:'πρέτσελ', it:'pretzel', ro:'covrig', uk:'крендель'}, src: require('@/assets/game-elements/bread_cereals_pasta/pretzel.png') },
          { category: "bread_cereals_pasta", name: {en:'small bread', el:'ψωμάκι', it:'pane piccolo', ro:'pâine mică', uk:'дрібний хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/small-bread-1.png') },
          { category: "bread_cereals_pasta", name: {en:'small bread', el:'ψωμάκι', it:'pane piccolo', ro:'pâine mică', uk:'дрібний хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/small-bread-2.png') },
          
          { category: "bread_cereals_pasta", name: {en:'bagel', el:'κουλούρι', it:'bagel', ro:'covrigi', uk:'бублик'}, src: require('@/assets/game-elements/bread_cereals_pasta/bagel.png') },
          { category: "bread_cereals_pasta", name: {en:'barley', el:'κριθάρι', it:'orzo', ro:'orz', uk:'ячмінь'}, src: require('@/assets/game-elements/bread_cereals_pasta/barley.png') },
          { category: "bread_cereals_pasta", name: {en:'breadsticks', el:'κριτσίνια', it:'grissini', ro:'grisine', uk:'хлібні палички'}, src: require('@/assets/game-elements/bread_cereals_pasta/breadsticks.png') },
          { category: "bread_cereals_pasta", name: {en:'brioche', el:'τσουρέκι', it:'brioche', ro:'brioşă', uk:'бріош'}, src: require('@/assets/game-elements/bread_cereals_pasta/brioche.png') },
          { category: "bread_cereals_pasta", name: {en:'buckwheat', el:'φαγόπυρο', it:'grano saraceno', ro:'hrişcă', uk:'гречана крупа'}, src: require('@/assets/game-elements/bread_cereals_pasta/buckwheat.png') },
          { category: "bread_cereals_pasta", name: {en:'cornbread', el:'καλαμποκένιο ψωμί', it:'pane di mais', ro:'pâine de porumb', uk:'кукурудзяний хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/cornbread.png') },
          { category: "bread_cereals_pasta", name: {en:'cornflakes', el:'νιφάδες καλαμποκιού', it:'cornflakes', ro:'fulgi de porumb', uk:'кукурудзяні пластівці'}, src: require('@/assets/game-elements/bread_cereals_pasta/cornflakes.png') },
          { category: "bread_cereals_pasta", name: {en:'croutons', el:'κρουτόν', it:'crostini', ro:'crutoane', uk:'грінки'}, src: require('@/assets/game-elements/bread_cereals_pasta/croutons.png') },
          { category: "bread_cereals_pasta", name: {en:'fettuccine', el:'ταλιατέλες', it:'fettuccine', ro:'fettuccine', uk:'фетучіні'}, src: require('@/assets/game-elements/bread_cereals_pasta/fettuccine.png') },
          { category: "bread_cereals_pasta", name: {en:'flatbread', el:'ψωμί', it:'pane piatto', ro:'pâine plate', uk:'лепешка'}, src: require('@/assets/game-elements/bread_cereals_pasta/flatbread.png') },
          { category: "bread_cereals_pasta", name: {en:'focaccia', el:'ελαιόψωμο', it:'focaccia', ro:'focaccia', uk:'фокачча'}, src: require('@/assets/game-elements/bread_cereals_pasta/focaccia.png') },
          { category: "bread_cereals_pasta", name: {en:'granola', el:'γκρανόλα', it:'granola', ro:'granola', uk:'гранола'}, src: require('@/assets/game-elements/bread_cereals_pasta/granola.png') },
          { category: "bread_cereals_pasta", name: {en:'macaroni', el:'μακαρόνια', it:'maccheroni', ro:'macaroane', uk:'макарони'}, src: require('@/assets/game-elements/bread_cereals_pasta/macaroni.png') },
          { category: "bread_cereals_pasta", name: {en:'muesli', el:'μούσλι', it:'muesli', ro:'musli', uk:'мюслі'}, src: require('@/assets/game-elements/bread_cereals_pasta/muesli.png') },
          { category: "bread_cereals_pasta", name: {en:'naan', el:'σκορδόψωμο', it:'naan', ro:'naan', uk:'наан'}, src: require('@/assets/game-elements/bread_cereals_pasta/naan.png') },
          { category: "bread_cereals_pasta", name: {en:'noodles', el:'νουντλς', it:'noodles', ro:'tăiței', uk:'локшина'}, src: require('@/assets/game-elements/bread_cereals_pasta/noodles.png') },
          { category: "bread_cereals_pasta", name: {en:'penne', el:'πένες', it:'penne', ro:'penne', uk:'пенне'}, src: require('@/assets/game-elements/bread_cereals_pasta/penne.png') },
          { category: "bread_cereals_pasta", name: {en:'pita', el:'πίτα', it:'pita', ro:'pita', uk:'лаваш'}, src: require('@/assets/game-elements/bread_cereals_pasta/pita.png') },
          { category: "bread_cereals_pasta", name: {en:'quinoa', el:'κινόα', it:'quinoa', ro:'quinoa', uk:'кіноа'}, src: require('@/assets/game-elements/bread_cereals_pasta/quinoa.png') },
          { category: "bread_cereals_pasta", name: {en:'rice', el:'ρύζι', it:'riso', ro:'orez', uk:'рис'}, src: require('@/assets/game-elements/bread_cereals_pasta/rice.png') },
          { category: "bread_cereals_pasta", name: {en:'rye bread', el:'σικαλένιο ψωμί', it:'pane di segale', ro:'pâine de secară', uk:'житній хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/rye_bread.png') },
          { category: "bread_cereals_pasta", name: {en:'sourdough', el:'προζυμένιο ψωμί', it:'pasta madre', ro:'aluat', uk:'закваска'}, src: require('@/assets/game-elements/bread_cereals_pasta/sourdough.png') },
          { category: "bread_cereals_pasta", name: {en:'spaghetti', el:'μακαρόνια', it:'spaghetti', ro:'spaghete', uk:'спагетті'}, src: require('@/assets/game-elements/bread_cereals_pasta/spaghetti.png') },
        ],

      },
      currentFoods: [],
      cart: {
        bread_cereals_pasta: [],
        fat_oil_sugar_sweets: [],
        fruits: [],
        vegetables: [],
        meat_fish_milk_eggs: [],
      },
      score: 0,
      timeLeft: 30,
      timer: null,
      badgeMessage: '',
      badgeType: '',
      scoreThreshold: 50,
      audio: null,
      roundLocked: false,
    };
  },
  methods: {
    log(evt) {
      window.console.log(evt);
    },
    async goBack() {
      sounds.whoosh.play();
      if (sounds.food_game) {
        sounds.food_game.stop();
      }
      this.$router.push({ name: 'GameSelection' });
    },
    startGame() {
      this.overlayMessage = {
          en: "Get ready to sort the food! Be quick, time is running!",
          el: "Ετοιμάσου να ταξινομήσεις το φαγητό! Βιάσου, ο χρόνος τελειώνει!",
          it: "Preparati a ordinare il cibo! Sii veloce, il tempo sta per scadere!",
          ro: "Pregătește-te să sortezi mâncarea! Fii rapid, timpul trece!",
          uk: "Приготуйся сортувати їжу! Швидше, час спливає!"
      };
      this.isOverlayVisible = true;
    },
    onStartGame() {
      Howler.ctx.resume();
      this.isOverlayVisible = false;
      this.resetGame();
      this.startTimer();

      // Play a sound
      sounds.start_sound.play();
      // Play background music after user interaction, with a short delay
      setTimeout(() => {
        sounds.food_game.play();
      }, 500);
    },
    resetGame() {
      this.score = 0;
      this.timeLeft = 30;
      this.loadNewFoods();
    },
    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft <= 0) {
          clearInterval(this.timer);
          this.endGame();
        }
      }, 1000);
    },
    loadNewFoods() {
      const allFoods = Object.values(this.categories).flat();

      // Filter out the foods that are already in the cart
      const usedFoods = Object.values(this.cart).flat();
      const availableFoods = allFoods.filter(food => !usedFoods.includes(food));

      // Shuffle the remaining foods and pick one
      this.currentFoods = this.shuffleArray(availableFoods).slice(0, 1);
    },
    shuffleArray(array) {
      return array.sort(() => Math.random() - 0.5);
    },
    placeFoodInCart(categoryKey) {
      if (this.roundLocked) return; // ignore extra drops after round ends
      this.roundLocked = true;
      console.log("categoryKey: ", categoryKey);

      // Get the first food item in the currentFoods array
      const foodItem = this.currentFoods[0];

      console.log("foodItem: ", foodItem);

      // Check if the selected food belongs to the correct category
      if (foodItem && foodItem.category === categoryKey) {
        // Add the selected food to the respective category in the cart
        this.cart[categoryKey].push(foodItem);

        const index = this.cart[categoryKey].indexOf(foodItem); // Find the index of the item
        if (index > -1) { // Ensure the item exists in the array
          this.cart[categoryKey].splice(index, 1); // Remove the item
        }

        // Remove the food from the currentFoods list (this will clear the array)
        this.currentFoods = this.currentFoods.filter(item => item !== foodItem); // This ensures the food item is properly removed

        // Increase score for correct placement
        this.score += 10;

        // Show success badge
        this.showBadge('success', this.correct_label[this.language]);
        // Play a sound
        sounds.score_sound.play();
      } else {
        // Show a message regardless of correct or wrong category
        this.showBadge('fail', this.wrong_label[this.language]);

        // Play a sound
        sounds.wrong_sound.play();
        const index = this.cart[categoryKey].indexOf(foodItem); // Find the index of the item
        if (index > -1) { // Ensure the item exists in the array
          this.cart[categoryKey].splice(index, 1); // Remove the item
        }
        this.loadNewFoods();
      }

      // If all current foods are sorted, load new foods
      if (this.currentFoods.length === 0) {
        this.loadNewFoods();
      }
      this.roundLocked = false;
    },
    showBadge(type, message) {
      this.badgeType = type;
      this.badgeMessage = message;
      setTimeout(() => {
        this.badgeMessage = '';
      }, 1000);
    },
    async updateSeedPoints(seedType, change) {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const response = await fetch("https://erebus2.athenarc.gr/duse/update-seed-points", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ seedType, change }),
    });

    if (response.ok) {
      console.log(`Seed points updated: ${change} to ${seedType}`);
    } else {
      console.error("Failed to update seed points.");
    }
  } catch (error) {
    console.error("Error updating seed points:", error);
  }
},
    async endGame() {
      if (sounds.food_game) {
        sounds.food_game.stop();
      }
      let seedType = "";
      let change = 0;

      if (this.score > this.scoreThreshold) {
        change = 1; // Win: Gain a seed
      } else {
        change = -1; // Lose: Lose a seed
      }

      if (this.score > this.scoreThreshold) {
        // Play a sound
        sounds.win_sound.play();
      } else {
        // Play a sound
        sounds.lose_sound.play();
      }

      console.log('END GAME DAYPART:', this.daypart);

      if (this.daypart == 'morning') {
        seedType = "blue";

        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en: `Congratulations! You scored ${this.score} points!`, el: `Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it: `Congratulazioni! Hai totalizzato ${this.score} punti!`, ro: `Felicitări! Ai obținut ${this.score} puncte!`, uk: `Вітаємо! Ви набрали ${this.score} балів!`};
          this.isMorningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en: `You scored ${this.score} points. Try again...`, el: `Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά...`, it: `Hai totalizzato ${this.score} punti. Riprova...`, ro: `Ai obținut ${this.score} puncte. Încearcă din nou...`, uk: `Ви набрали ${this.score} балів. Спробуйте ще раз...`};         
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'noon') {
        seedType = "red";

        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en: `Congratulations! You scored ${this.score} points!`, el: `Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it: `Congratulazioni! Hai totalizzato ${this.score} punti!`, ro: `Felicitări! Ai obținut ${this.score} puncte!`, uk: `Вітаємо! Ви набрали ${this.score} балів!`};
          this.isNoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en: `You scored ${this.score} points. Try again...`, el: `Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά...`, it: `Hai totalizzato ${this.score} punti. Riprova...`, ro: `Ai obținut ${this.score} puncte. Încearcă din nou...`, uk: `Ви набрали ${this.score} балів. Спробуйте ще раз...`};          
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
          this.isNoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'afternoon') {
        seedType = "green";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en: `Congratulations! You scored ${this.score} points!`, el: `Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it: `Congratulazioni! Hai totalizzato ${this.score} punti!`, ro: `Felicitări! Ai obținut ${this.score} puncte!`, uk: `Вітаємо! Ви набрали ${this.score} балів!`};
          this.isAfternoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en: `You scored ${this.score} points. Try again...`, el: `Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά...`, it: `Hai totalizzato ${this.score} punti. Riprova...`, ro: `Ai obținut ${this.score} puncte. Încearcă din nou...`, uk: `Ви набрали ${this.score} балів. Спробуйте ще раз...`};          
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
          this.isAfternoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'night') {
        seedType = "yellow";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en: `Congratulations! You scored ${this.score} points!`, el: `Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it: `Congratulazioni! Hai totalizzato ${this.score} punti!`, ro: `Felicitări! Ai obținut ${this.score} puncte!`, uk: `Вітаємо! Ви набрали ${this.score} балів!`};
          this.isEveningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en: `You scored ${this.score} points. Try again...`, el: `Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά...`, it: `Hai totalizzato ${this.score} punti. Riprova...`, ro: `Ai obținut ${this.score} puncte. Încearcă din nou...`, uk: `Ви набрали ${this.score} балів. Спробуйте ще раз...`};          
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
          this.isEveningLoseOverlayVisible = true; // Show overlay at the end
        }
      }
      // Send seed update to the backend
      await this.updateSeedPoints(seedType, change);
      clearInterval(this.timer);
      setTimeout(() => {
        this.$router.push({ name: 'GameSelection' }); // Redirect after delay
      }, 3000); // 3 seconds delay
    },
    formatCategoryName(categoryKey) {
      return categoryKey.replace(/_/g, ', ').replace(/\b\w/g, (char) => char.toUpperCase());
    },

    async storeInIndexedDB(gameState) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);
    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("gameStates")) {
        db.createObjectStore("gameStates", { keyPath: "id", autoIncrement: true });
      }
    };

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      // Check for existing game state before saving
      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        const existingRecords = getAllRequest.result;
        const duplicate = existingRecords.find(
          (record) => record.gameName === gameState.gameName && record.datePlayed === gameState.datePlayed
        );

        if (!duplicate) {
          store.add(gameState);
        } else {
          console.warn("Duplicate game state detected. Skipping save.");
        }

        resolve();
      };

      getAllRequest.onerror = function (event) {
        reject("Error checking existing records:", event.target.error);
      };
    };

    request.onerror = function (event) {
      reject("Error opening IndexedDB:", event.target.error);
    };
  });
}
,

async getUnsyncedGameStates() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readonly");
      const store = transaction.objectStore("gameStates");

      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        resolve(getAllRequest.result);
      };
      getAllRequest.onerror = function (event) {
        reject("Error retrieving game states:", event.target.error);
      };
    };
  });
},

async deleteSyncedGameStates(syncedGames) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      syncedGames.forEach((game) => {
        store.delete(game.id); // Delete only specific records
      });

      resolve();
    };

    request.onerror = function (event) {
      reject("Error clearing IndexedDB:", event.target.error);
    };
  });
}
,
async syncWithMongo() {
  if (this.isSyncing) return; // Prevent duplicate sync
  this.isSyncing = true;

  const token = localStorage.getItem("token");
  if (!token) {
    console.error("User not authenticated. Cannot sync.");
    this.isSyncing = false;
    return;
  }

  try {
    const unsyncedGames = await this.getUnsyncedGameStates();
    if (unsyncedGames.length === 0) {
      console.log("No game states to sync.");
      this.isSyncing = false;
      return;
    }

    const response = await fetch("https://erebus2.athenarc.gr/duse/save-game-state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ gameStates: unsyncedGames }),
    });

    if (response.ok) {
      console.log("Game states synced successfully.");
      await this.deleteSyncedGameStates(unsyncedGames);
    } else {
      console.error("Failed to sync game states.");
    }
  } catch (error) {
    console.error("Error syncing with MongoDB:", error);
  } finally {
    this.isSyncing = false; // Ensure flag is reset
  }
},
    async saveGameState() {
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");

  if (!username) {
    console.error("User not logged in. Cannot save game state.");
    return;
  }

  const gameState = {
    username,
    gameName: this.$route.name,
    score: this.score,
    datePlayed: new Date().toISOString(),
  };

  try {
    // Store in IndexedDB regardless of network status
    await this.storeInIndexedDB(gameState);

    if (navigator.onLine && token) {
      await this.syncWithMongo();
    } else {
      console.warn("No internet connection. Game state saved locally.");
    }
  } catch (error) {
    console.error("Error saving game state:", error);
  }
},

  },
  computed: {
    categoryBackgrounds() {
      return {
        bread_cereals_pasta: require(`@/assets/game-elements/${this.language}_bread_yellow_cart.png`),
        fat_oil_sugar_sweets: require(`@/assets/game-elements/${this.language}_fats_purple_cart.png`),
        fruits: require(`@/assets/game-elements/${this.language}_fruits_red_cart.png`),
        vegetables: require(`@/assets/game-elements/${this.language}_vegetables_green_cart.png`),
        meat_fish_milk_eggs: require(`@/assets/game-elements/${this.language}_meat_blue_cart.png`),
      };
    }
  },
  created()
  {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
  },
  mounted() {
  console.log("Current route path:", this.$route.path);

  const daypart = this.$route.path.split("/")[2] || "daypart";
  this.daypart = daypart;
  this.startGame();

  // Check for internet connectivity
  window.addEventListener("online", async () => {
    console.log("Back online! Syncing game states...");
    await this.syncWithMongo();
  });
},
  beforeUnmount() {
    clearInterval(this.timer);
    if (sounds.food_game) {
      sounds.food_game.stop();
    }
    this.saveGameState();
  },
  beforeRouteLeave(to, from, next) {
    if (sounds.food_game) {
      sounds.food_game.stop();
    }
    // Save game state when the user navigates away
    this.saveGameState();
    next();
  },
};
</script>

<style scoped>
.middle-left-container {
  position: fixed;
  top: 50%;
  left: 1%;
  transform: translateY(-50%);
  width: 200px;
  color: white;
  font-size: 5vw;
}

.middle-right-container-1 {
  position: fixed;
  top: 26%;
  right: 1%;
  transform: translateY(-50%);
  width: 200px;
  color: white;
}

.middle-right-container-2 {
  position: fixed;
  top: 42%;
  right: 1%;
  transform: translateY(-50%);
  width: 200px;
  color: white;
}

.middle-right-container-3 {
  position: fixed;
  top: 58%;
  right: 1%;
  transform: translateY(-50%);
  width: 200px;
  color: white;
}

.middle-right-container-4 {
  position: fixed;
  top: 74%;
  right: 1%;
  transform: translateY(-50%);
  width: 200px;
  color: white;
}

.middle-right-container-5 {
  position: fixed;
  top: 90%;
  right: 1%;
  transform: translateY(-50%);
  width: 200px;
  color: white;
}

.horizontal-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.horizontal-list .list-group-item {
  flex: 0 0 auto;
}

.game-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: manual;
}

.game-stats {
  position: absolute;
  top: 20px;
  right: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* background: rgba(0, 0, 0, 0.5); */
  padding: 10px;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-weight: bold;
}

.food-container-item img {
  max-width: 100px;
  max-height: 100px;
  width: auto;
  height: auto;
  object-fit: cover;
}

.list-group-item img {
  max-width: 20px;
  max-height: 20px;
  width: auto;
  height: auto;
  object-fit: cover;
}

#food-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  margin-left: 10vw;
}

#cart-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
}

.badge.success {
  background-color: green;
}

.badge.fail {
  background-color: red;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  z-index: 1001;
}

/* Ensure the drop area has fixed dimensions */
.list-group.horizontal-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* Align items vertically if necessary */
  justify-content: center;
  /* Align items horizontally */
  height: 50px;
  /* Fixed height */
  width: 100%;
  /* Adjust width as needed */
  box-sizing: border-box;
  /* Include padding in the element's dimensions */
}

.food-container-item div {
  font-size: 4vmin;
  text-align: center;
  color: white;
}

</style>


